import { Schema } from 'prosemirror-model';
import {
  Blockquote,
  Bold,
  BulletList,
  CodeBlockHighlight,
  Heading,
  ListItem,
  Strike,
  Link,
  // TrailingNode,
} from 'tiptap-extensions';

const schema: any = {
  nodes: {
    code_block: new CodeBlockHighlight().schema,
    blockquote: new Blockquote().schema,
    bullet_list: new BulletList().schema,
    heading: new Heading({ levels: [2] }).schema,
    list_item: new ListItem().schema,
    doc: {
      content: 'block+',
    },
    title: {
      content: 'inline*',
      parseDOM: [
        {
          tag: 'h1',
        },
      ],
    },
    text: {
      group: 'inline',
    },
    paragraph: {
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: [
        {
          tag: 'p',
        },
      ],
    },
    hard_break: {
      inline: true,
      group: 'inline',
      selectable: false,
      parseDOM: [
        {
          tag: 'br',
        },
      ],
    },
  },
  marks: {
    bold: new Bold().schema,
    link: new Link().schema,
    strike: new Strike().schema,
    code: {
      parseDOM: [
        {
          tag: 'code',
        },
      ],
    },
  },
};

export default new Schema(schema);
